var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{staticClass:"inline"},[(_vm.$store.state.channel.currentJazzyLiveShow.show.slug === _vm.slug)?_c('span',{staticClass:"w-2 h-2 min-w-[8px] min-h-[8px] mr-1 mb-0.5 rounded-full bg-red-500"}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"inline"},[_vm._v(" "+_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }